/*
 * 自定义列组件配置
 * author: nicywang
 * time: 2020-09-01
 */
import _ from 'lodash';
// 除自定义标签之外的其他字段，保持各个页面同一字段用同一名字
import { valueNameMap } from './adrptCellConfig';
const columnNameValueMap = {
  operator_name: '运营人员',
  date: '日期',
  uid: '帐号ID',
  cid: '推广计划ID',
  aid: '营销单元ID',
  appid: 'APPID',
  wechat_account_type_name: '帐号类型',
  buying_type_name: '帐号类型',
  customer_status_name: '帐号状态',
  wechat_auth_status_name: '帐号状态',
  pay_check_status_name: '对公打款验证状态',
  reg_date: '开户日期',
  uname: '帐号名称|账户名称',
  company_name: '主体名称',
  wxname: '原始ID',
  agency_uid: '所属服务商ID',
  spid: '所属服务商SPID',
  agency_name: '所属服务商名称',
  agency_remark: '所属服务商简称',
  industry_name: '客户行业',
  master_user_id: '主要运营人员',
  operator_list: '运营人员',
  design_operator_list: '设计师',
  observer_operator_list: '观察者',
  '1000': '运营方式',
  self_operator_list: '自理投放管理员',
  auth_time: '授权时间',
  total_balance: '账户余额(元)',
  day_budget: '竞价投放日预算(元)',
  trade_count: '目标转化量',
  click_trade_rate: '目标转化率',
  cash_cost: '现金消耗(元)',
  credit_cost: '信用金消耗(元)',
  virtual_cost: '虚拟金消耗(元)',
  gift_cost: '赠送金消耗(元)',
  first_cost_date: '首次消耗日期',
  last_cost_date: '最近消耗日期',
  today_cost: '今日消耗(元)',
  yesterday_cost: '昨日消耗(元)',
  predict_cost_days: '预计消耗(天)', // mp在用
  predict_remain_days_name: '预计消耗(天)', // adq在用
  recommended_charge_amount: '建议充值金额(元)', // 用测试的v_xmfeili
  impression_affaction_level: '账户受到余额/预算影响',
  total_cost: '总消耗(元)',
  view_count: '曝光量',
  valid_click_count: '点击量',
  ctr: '点击率',
  cpc: '点击均价(元)',
  ecpm: 'eCPM',
  remark: '备注',
  wxid: '原始ID',
  wechat_uname: '公众号名称',
  order_sale: '提单销售',
  dispatch_date: '分户日期',
  first_expose_date: '首次曝光日期',
  operator_team_list: '运营人员部门',
  area_name: '地域',
  first_charge_date: '首充时间',
  first_charge_amount: '首充金额',
  user_id: '员工ID',
  name: '员工姓名',
  number: '工号',
  mobile: '手机号',
  qq_number: '登录QQ号',
  wechat_number: '登录微信号',
  identification_number: '身份证号',
  email: '邮箱',
  activate_date: '在职时间',
  role_list: '角色',
  role_memo_name: '角色备注',
  post_name: '岗位',
  type: '员工类型',
  team_list: '团队',
  title: '职务',
  seat_sip: '坐席分机',
  seat_telephone: '坐席固话',
  seat_mobile: '坐席手机',
  seat_no: '坐席号',
  skill_group_name_list: '坐席角色技能',
  mobile_match_status: '营销学堂',
  product_type_name: '推广目标',
  placement_group_name: '投放版位',
  position_name: '广告位',
  cost_type_name: '购买方式',
  arpu: 'ARPU',
  ...valueNameMap,
  status: '在职状态',
  work_wechat_user_id: '企业微信',
  collocation_status_text: '托管状态',
  auto_transfer_valid_name: '自动转账功能',
  is_self_manage_fund: '支持客户资金自理',
  is_cross_k_frame_transfer: '支持客户跨框转账',
  cash_balance: '现金余额(元)',
  credit_balance: '信用金余额(元)',
  virtual_balance: '虚拟金余额(元)',
  gift_balance: '赠送金余额(元)',
  daily_cost: '今日消耗(元)',
  advertiser_bm_id: '商务管家ID',
  advertiser_bm_name: '所属商务管家名称',
  inner_balance: '专项金余额（元）',
  tcc_gift_balance: 'TCC赠送金余额（元）',
  debt_temp_balance: '信用金临时余额（元）',
  debt_fixed_balance: '信用金固定余额（元）',
  finance_record_type: '记录类型',
  trans_time: '日期',
  agency_id: '所属服务商ID',
  advertiser_name: '帐号名称',
  advertiser_id: '帐号ID',
  bill_no: '订单号',
  fund_type_name: '资金类型',
  account_type_name: '资金账户名称',
  finance_operation_type: '操作类型',
  finance_biz_type: '业务类型',
  finance_inout_type: '收支类型',
  additional_info: '备注',
  op_time: '操作日期',
  src_account: '转出服务商ID',
  dst_account: '转入服务商ID',
  sub_account_group_name: '资金类型',
  sub_account_name: '资金账户类型',
  amount: '金额（元）',
  recover_apply_status: '申请状态',
  op_user: '操作人',
  desc: '备注',
  agency_op_type: '操作类型',
  advertiser_op_type: '操作类型',
  app_id_group_name: '资金类型',
  app_id_name: '资金账户名称',
  trans_name: '操作类型',
  agency_type_name: '所属服务商类型',
  operator: '操作人',
  cname: '推广计划名称',
  aname: '营销单元名称',
  // 新增字段
  pay_virtual_cost: '补偿虚拟金消耗',
  insourced_give_cost: '小游戏内购赠送金消耗',
  insourced_turnover_cost: '小游戏内购快周转资金消耗',
  return_goods_cost: '专用金消耗',
  k_frame: 'K框',
  group_name: '客户集团',
  is_local_business: '附近推帐号',
  redcover_cost: '红包封面消耗',
  compensate_cost: '赔偿金消耗',
  gift_android_cost: '安卓定向应用金消耗',
  '1002': '客户付款类型',
  creative_review_score: '创意审核通过率',
  sale_operator_list: '维护销售',
  main_sale_operator_list: '主要维护销售',
  link_person_list: '账户联系人',
  account_open_user: '开户销售',
  is_store_flow: '是否门店通',
};
// 自定义面板所有的属性
const cellsAttrArray = [
  {
    name: '属性指标',
    fields: 'date,uname,appid,uid,k_frame,group_name,spid,wxname,company_name,wechat_account_type_name,aid,cid,buying_type_name,industry_name,customer_status_name,wechat_auth_status_name,operator_name,agency_uid,agency_name,reg_date,auth_time,wxid,wechat_uname,user_id,name,number,mobile,qq_number,wechat_number,identification_number,email,activate_date,role_list,role_memo_name,post_name,type,team_list,title,seat_sip,seat_telephone,seat_mobile,seat_no,skill_group_name_list,mobile_match_status,placement_group_name,position_name,cost_type_name,product_type_name,collocation_status_text,pay_check_status_name,status,work_wechat_user_id,auto_transfer_valid_name,is_self_manage_fund,finance_record_type,trans_time,agency_id,advertiser_name,advertiser_id,bill_no,fund_type_name,account_type_name,finance_operation_type,finance_biz_type,finance_inout_type,additional_info,op_time,src_account,dst_account,sub_account_group_name,sub_account_name,recover_apply_status,op_user,desc,agency_op_type,advertiser_op_type,app_id_name,app_id_group_name,trans_name,operator,agency_type_name,area_name,is_local_business,partner_employ_id,partner_industries,agency_remark',
  },
  {
    name: '数据指标',
    fields:
      'amount,first_cost_date,last_cost_date,predict_cost_days,total_balance,recommended_charge_amount,impression_affaction_level,predict_remain_days_name,day_budget,cash_balance,credit_balance,virtual_balance,gift_balance,view_count,valid_click_count,ctr,cpc,pay_virtual_cost,insourced_give_cost,insourced_turnover_cost,return_goods_cost,trade_count,cash_cost,credit_cost,virtual_cost,gift_cost,total_cost,today_cost,yesterday_cost,ecpm,wechat_ecoupon_cost,wechat_special_cost,wechat_credit_cost,wechat_tcc_cost,wechat_debt_fixed_cost,wechat_debt_temp_cost,conversions_count,conversions_rate,conversions_cost,arpu,inner_balance,tcc_gift_balance,debt_fixed_balance,debt_temp_balance,dispatch_date,first_expose_date,first_charge_date,first_charge_amount,redcover_cost,compensate_cost,gift_android_cost,creative_review_score',
  },
  {
    name: '标签指标',
    fields: '1000,1002,is_store_flow',
  },
  {
    name: '其他指标',
    fields: 'operator_list,operator_team_list,self_operator_list,design_operator_list,observer_operator_list,remark,order_sale,link_person_list,sale_operator_list,main_sale_operator_list,account_open_user',
  },
  {
    name: '基础信息',
    fields: 'service_parent_id,service_provider_name,period,policy_type',
  },
  {
    name: '服务商信息',
    fields: 'agent_uin,platform_ad_id,public_id',
  },
  {
    name: '账户信息',
    fields: 'consume_source,corporation_name,uid_agent_uin,customer_type,customer_name',
  },
  {
    name: '投放信息',
    fields: 'delivery_mode,final_amount,ad_schedul_id,consume_amount,is_fb,ad_loc',
  },
  {
    name: '政策信息',
    fields:
      'policy_safely_fix_amt,lkbq,return_point_goods,k_frame_xz,qk_hsxx,investment_tag,policy_inner,policy_investment_label,invest_level,investment_label,investment_year,custome_classify,consume1000,consume3000,bca_label,ecology_label,ecology_type,interal_label,nxzj_amount,is_wgft,wgft_rate,first_resource,second_resource,newCust_label,dwcl,ll_province,sfps,policy_e_amt,policy_ss_amt,policyTAmt,policy_b_amt,policy_local_amt,policy_new_kh_amt,policy_fc_kh_amt,policy_zs_amt,policy_hyjl_amt,policy_zmt_amt,policy_best_fix_amt_total,wgft_amount',
  },
  {
    name: '财务信息',
    fields: 'financial_label,ou',
  },
  {
    name: '归属信息',
    fields: 'qdgs,industry_label,industry_first_label,industry_second_label',
  },
  {
    name: '牌照信息',
    fields: 'province,city,car_license,zsjm_license,zyds_license,fc_license,qy_license,qyzw_license,qylk_license,qylu_license,yys_license,yys_region,car_region,fcdq,fcjt_name,fcfbqy,area',
  },
];

// 根据页面类型返回默认列数据
export const getDefaultColumnsByPageId = function (pageId) {
  let result = '';

  switch (pageId) {
    // 账户列表-ADQ营销
    case 'advertising':
      result = 'uname,uid|k_frame,group_name,customer_status_name,pay_check_status_name,recommended_charge_amount,impression_affaction_level,buying_type_name,reg_date,total_balance,predict_remain_days_name,day_budget,first_cost_date,last_cost_date,operator_list,self_operator_list,design_operator_list,auto_transfer_valid_name';
      break;
    // 账户列表-MP营销
    case 'wechatlist':
      result = 'uname,uid,appid|k_frame,group_name,sale_operator_list,main_sale_operator_list,account_open_user,wechat_auth_status_name,wechat_account_type_name,total_balance,first_cost_date,last_cost_date,operator_list';
      break;
    // 账户列表-CPS商品
    case 'cpslist':
      result = 'uname,uid|k_frame,group_name,customer_status_name,sale_operator_list,main_sale_operator_list,account_open_user,buying_type_name,total_balance,reg_date,operator_list,link_person_list';
      break;
    // 投放平台-ADQ营销
    case 'accountlist':
      result = 'uname,uid|k_frame,group_name,date,recommended_charge_amount,impression_affaction_level,industry_name,total_cost,view_count,ctr,cpc,trade_count,operator_list,1000,design_operator_list';
      break;
    // 投放平台-MP营销
    case 'wechatrpt':
      result = 'uname,uid,appid|k_frame,group_name,date,wechat_account_type_name,industry_name,total_balance,operator_list,1000';
      break;
    case 'adrpt':
      result = 'date,uname,uid|industry_name,cost,view_count,valid_click_count,ctr,cpc,conversions_count,conversions_rate,ecpm';
      break;
    case 'basic':
      result = 'date,agency_uid,industry_name,operator_name,total_cost|view_count,valid_click_count,ctr,cpc,conversions_count,conversions_rate,conversions_cost,ecpm';
      break;
    case 'basic-2':
      result = 'date,total_cost|cash_cost,wechat_ecoupon_cost,wechat_special_cost,wechat_credit_cost,wechat_tcc_cost,wechat_debt_fixed_cost,wechat_debt_temp_cost';
      break;
    case 'advertise-2':
      result = 'date,uid,total_cost|uname,appid,wxid,industry_name,view_count,valid_click_count,ctr,ecpm';
      break;
    // 账户维度-明细报表
    case 'advertisereportNew':
      result = 'date,uid,total_cost|k_frame,group_name,appid,uname,agency_uid,view_count,valid_click_count,ctr,cpc,conversions_count,conversions_rate,conversions_cost,ecpm';
      break;
    // 账户维度-基础报表
    case 'advertisereport':
      result = 'uname,uid,appid|k_frame,group_name,date,operator_name,total_cost,view_count,ctr,cpc,ecpm';
      break;
    case 'employee':
      result = 'user_id,name|status,wechat_number,work_wechat_user_id,team_list,role_list,role_memo_name,partner_employ_id,partner_industries';
      break;
    case 'rebate':
      result = 'uid,customer_name|service_parent_id,service_provider_name,uid_agent_uin,agent_uin,period,policy_type,consume_source,account_type_name,delivery_mode,lkbq,return_point_goods,final_amount,policy_safely_fix_amt,policy_b_amt,policy_t_amt,policy_zs_amt,policy_best_fix_amt_total,k_frame_xz,ll_province,';
      break;
    case 'gdtinfo':
      result = 'uname,uid|buying_type_name,recommended_charge_amount,impression_affaction_level,reg_date,agency_uid,customer_status_name,industry_name,total_balance,predict_remain_days_name,cash_balance,credit_balance,virtual_balance,gift_balance,daily_cost,day_budget,advertiser_bm_id,advertiser_bm_name,is_self_manage_fund,is_cross_k_frame_transfer,auto_transfer_valid_name';
      break;
    case 'wxinfo':
      result = 'uname,appid|wxname,uid,wechat_account_type_name,company_name,industry_name,total_balance,cash_balance,gift_balance,inner_balance,credit_balance,tcc_gift_balance,debt_fixed_balance,debt_temp_balance';
      break;
    case 'cpsinfo':
      result = 'uname,uid|reg_date,agency_uid,customer_status_name,industry_name,total_balance,cash_balance,credit_balance';
      break;
    case 'finance_record_cps':
      result = 'trans_time|agency_uid,uname,uid,bill_no,app_id_group_name,app_id_name,trans_name,amount,desc';
      break;
    case 'finance_record_agency':
      result = 'finance_record_type,trans_time|agency_id,advertiser_name,advertiser_id,bill_no,fund_type_name,account_type_name,finance_operation_type,finance_biz_type,finance_inout_type,amount,additional_info';
      break;
    case 'wx_finance_record_advertiser':
      result = 'op_time,advertiser_op_type|bill_no,agency_uid,uname,company_name,wxid,appid,wechat_account_type_name,sub_account_group_name,sub_account_name,amount,recover_apply_status,op_user,desc';
      break;
    case 'wx_finance_record_agency':
      result = 'op_time,agency_op_type|bill_no,spid,sub_account_group_name,sub_account_name,src_account,dst_account,amount,recover_apply_status,op_user,desc';
      break;
  }

  return result;
};

// 广告主管理-广告主列表-ADQ营销-全
const advertising = [
  { name: 'uname', useSelfRender: true, align: 'left' },
  { name: 'uid', useSelfRender: true },
  { name: 'k_frame', useSelfRender: true },
  { name: 'group_name', useSelfRender: true },
  { name: 'recommended_charge_amount', align: 'left' },
  { name: 'impression_affaction_level', align: 'left' },
  { name: 'total_balance', useSelfRender: true, align: 'right' },
  { name: 'agency_uid' },
  { name: 'agency_type_name' },
  { name: 'buying_type_name', condition: 'isAdx' },
  { name: 'customer_status_name', useSelfRender: true },
  { name: 'pay_check_status_name', useSelfRender: true }, // 打款验证状态
  { name: 'reg_date' },
  { name: 'industry_name' },
  { name: 'first_cost_date', useSelfRender: true },
  { name: 'last_cost_date', useSelfRender: true },
  { name: 'predict_remain_days_name', useSelfRender: true },
  { name: 'day_budget', useSelfRender: true, align: 'left' },
  { name: 'operator_list', useSelfRender: true, maxWidth: '200', siblings: [{ name: 'main_operator_list', label: '主要运营人员', useSelfRender: true }] },
  { name: 'design_operator_list', useSelfRender: true, maxWidth: '200' },
  { name: 'self_operator_list', useSelfRender: true, maxWidth: '200' },
  { name: '1000', isLabel: true, useSelfRender: true, maxWidth: '200' },
  { name: 'remark', useSelfRender: true },
  { name: 'auto_transfer_valid_name' },
  { name: 'collocation_status_text', useSelfRender: true },
  { name: 'order_sale', useSelfRender: true },
  { name: 'dispatch_date' },
  { name: 'first_expose_date' },
  { name: 'operator_team_list' },
  { name: 'area_name' },
  { name: 'first_charge_amount' },
  { name: 'first_charge_date' },
  { name: 'is_local_business' },
];

const wechatlist = [
  { name: 'uname', useSelfRender: true },
  { name: 'company_name' },
  { name: 'uid' },
  { name: 'k_frame', useSelfRender: true },
  { name: 'group_name', useSelfRender: true },
  { name: 'appid', useSelfRender: true },
  { name: 'wxname', useSelfRender: true },
  { name: 'spid', useSelfRender: true },
  { name: 'agency_type_name' },
  { name: 'wechat_account_type_name', useSelfRender: true },
  { name: 'auth_time', useSelfRender: true },
  { name: 'industry_name' },
  { name: 'sale_operator_list', useSelfRender: true },
  { name: 'main_sale_operator_list', useSelfRender: true },
  { name: 'account_open_user', useSelfRender: true },
  { name: 'wechat_auth_status_name', useSelfRender: true },
  { name: 'first_cost_date', useSelfRender: true },
  { name: 'last_cost_date', useSelfRender: true },
  { name: 'total_balance', useSelfRender: true },
  { name: 'operator_list', useSelfRender: true, maxWidth: '200', siblings: [{ name: 'main_operator_list', label: '主要运营人员', useSelfRender: true }] },
  { name: 'observer_operator_list', useSelfRender: true, maxWidth: '200' },
  { name: '1000', isLabel: true, useSelfRender: true, maxWidth: '200' },
  { name: 'remark', useSelfRender: true },
  { name: 'order_sale', useSelfRender: true },
  { name: 'dispatch_date' },
  { name: 'first_expose_date' },
  { name: 'operator_team_list' },
  { name: 'area_name' },
  { name: 'first_charge_amount' },
  { name: 'first_charge_date' },
  { name: '1002', useSelfRender: true, maxWidth: '200' },
  // { name: 'creative_review_score', useSelfRender: true },
];

const cpslist = [
  { name: 'uname', useSelfRender: true },
  { name: 'uid', useSelfRender: true },
  { name: 'k_frame', useSelfRender: true },
  { name: 'group_name', useSelfRender: true },
  { name: 'agency_uid' },
  { name: 'agency_type_name' },
  { name: 'buying_type_name', condition: 'isAdx' },
  { name: 'sale_operator_list', useSelfRender: true },
  { name: 'main_sale_operator_list', useSelfRender: true },
  { name: 'account_open_user', useSelfRender: true },
  { name: 'customer_status_name', useSelfRender: true },
  { name: 'reg_date' },
  { name: 'industry_name' },
  { name: 'total_balance', useSelfRender: true },
  { name: 'operator_list', useSelfRender: true, maxWidth: '200' },
  { name: '1000', isLabel: true, useSelfRender: true, maxWidth: '200' },
  { name: 'remark', useSelfRender: true },
  { name: 'area_name' },
  { name: '1002', useSelfRender: true, maxWidth: '200' },
  { name: 'link_person_list', useSelfRender: true },
  { name: 'agency_name' },
  { name: 'agency_remark' },
  { name: 'is_store_flow' },
  // { name: 'creative_review_score', useSelfRender: true },
];

// 投放平台-ADQ营销
const accountlist = [
  { name: 'uname', useSelfRender: true },
  { name: 'date' },
  { name: 'uid', useSelfRender: true },
  { name: 'k_frame', useSelfRender: true },
  { name: 'group_name', useSelfRender: true },
  { name: 'industry_name' },
  { name: 'view_count', maxWidth: '200', align: 'left', sortable: true },
  { name: 'valid_click_count', maxWidth: '200', align: 'left', sortable: true },
  { name: 'ctr', align: 'left', maxWidth: '200', sortable: true },
  { name: 'cpc', align: 'left', maxWidth: '200', sortable: true },
  { name: 'trade_count', align: 'left', sortable: true },
  { name: 'click_trade_rate', align: 'left', sortable: true },
  { name: 'cash_cost', align: 'left', maxWidth: '200', useSelfRender: true },
  { name: 'recommended_charge_amount' },
  { name: 'impression_affaction_level' },
  { name: 'credit_cost', align: 'left', maxWidth: '200', useSelfRender: true },
  { name: 'virtual_cost', align: 'left', maxWidth: '200', useSelfRender: true },
  { name: 'gift_cost', align: 'left', maxWidth: '200', useSelfRender: true },
  { name: 'total_cost', useSelfRender: true, align: 'left', sortable: true, maxWidth: '200' },
  { name: 'operator_list', useSelfRender: true, maxWidth: '200', siblings: [{ name: 'main_operator_list', label: '主要运营人员', useSelfRender: true }] },
  { name: 'design_operator_list', useSelfRender: true, maxWidth: '200' },
  { name: '1000', isLabel: true, useSelfRender: true, maxWidth: '200' },
  { name: 'collocation_status_text', useSelfRender: true },
  { name: 'remark', useSelfRender: true },
  { name: 'order_sale' },
  { name: 'area_name' },
];

// 投放平台-MP营销
const wechatrpt = [
  { name: 'uname', useSelfRender: true },
  { name: 'date' },
  { name: 'company_name' },
  { name: 'uid', useSelfRender: true },
  { name: 'k_frame', useSelfRender: true },
  { name: 'group_name', useSelfRender: true },
  { name: 'appid', useSelfRender: true },
  { name: 'wxname', useSelfRender: true },
  { name: 'wechat_account_type_name' },
  { name: 'industry_name' },
  { name: 'total_balance', useSelfRender: true },
  { name: 'operator_list', useSelfRender: true, maxWidth: '200', siblings: [{ name: 'main_operator_list', label: '主要运营人员', useSelfRender: true }] },
  { name: '1000', isLabel: true, useSelfRender: true, maxWidth: '200' },
  { name: 'remark', useSelfRender: true },
  { name: 'order_sale' },
  { name: 'area_name' },
];

// 营销单元维度报表
const adrpt = [
  { name: 'date', sortable: true },
  { name: 'uname' },
  { name: 'uid' },
  { name: 'appid' },
  { name: 'wxid' },
  { name: 'wechat_uname' },
  { name: 'aid' },
  { name: 'cid' },
  { name: 'agency_uid' },
  { name: 'agency_name' },
  { name: 'cost', sortable: true },
  { name: 'position_name', useSelfRender: true },
  { name: 'placement_group_name', useSelfRender: true },
  { name: 'product_type_name', useSelfRender: true },
  { name: 'cost_type_name', useSelfRender: true },
  { name: 'industry_name', useSelfRender: true },
  { name: 'operator_name', useSelfRender: true, maxWidth: '200', label: '主要运营人员' },
  { name: 'view_count', sortable: true },
  { name: 'valid_click_count', sortable: true },
  { name: 'conversions_count', sortable: true },
  { name: 'conversions_rate', sortable: true, useSelfRender: true },
  { name: 'conversions_cost' },
  { name: 'ctr', sortable: true },
  { name: 'cpc', useSelfRender: true, maxWidth: '200' },
  { name: 'ecpm', useSelfRender: true },
];
// 基础报表
const basic = [
  { name: 'date', sortable: true },
  { name: 'industry_name', useSelfRender: true },
  { name: 'position_name', useSelfRender: true },
  { name: 'product_type_name', useSelfRender: true },
  { name: 'placement_group_name', useSelfRender: true },
  { name: 'agency_uid' },
  { name: 'cost_type_name', useSelfRender: true },
  { name: 'total_cost', useSelfRender: true, align: 'left', sortable: true, maxWidth: '200' },
  { name: 'cash_cost', useSelfRender: true },
  { name: 'credit_cost', useSelfRender: true },
  { name: 'virtual_cost', useSelfRender: true },
  { name: 'gift_cost', useSelfRender: true },
  { name: 'wechat_debt_fixed_cost', useSelfRender: true },
  { name: 'wechat_debt_temp_cost', useSelfRender: true },
  { name: 'wechat_ecoupon_cost', useSelfRender: true },
  { name: 'wechat_special_cost', useSelfRender: true },
  { name: 'wechat_credit_cost', useSelfRender: true },
  { name: 'wechat_tcc_cost', useSelfRender: true },
  { name: 'operator_name', useSelfRender: true, maxWidth: '200', label: '主要运营人员' },
  { name: 'view_count', sortable: true, useSelfRender: true },
  { name: 'valid_click_count', sortable: true, useSelfRender: true },
  { name: 'ctr', sortable: true, useSelfRender: true },
  { name: 'cpc', useSelfRender: true, useSelfRender: true },
  { name: 'ecpm', useSelfRender: true, useSelfRender: true },
  { name: 'conversions_count', sortable: true, useSelfRender: true },
  { name: 'conversions_rate', sortable: true, useSelfRender: true },
  { name: 'conversions_cost', useSelfRender: true },
  { name: 'redcover_cost', useSelfRender: true },
  { name: 'compensate_cost' },
  { name: 'gift_android_cost' },
  // { name: "arpu" },
];

// 广告主维度报表-新
const advertisereportNew = [
  { name: 'uid' },
  { name: 'appid' },
  { name: 'uname' },
  { name: 'agency_uid' },
  { name: 'wxid' },
  { name: 'wechat_uname' },
  { name: 'k_frame' },
  { name: 'group_name' },
  { name: 'industry_name', useSelfRender: true },
  { name: 'date', sortable: true },
  { name: 'position_name', useSelfRender: true },
  { name: 'product_type_name', useSelfRender: true },
  { name: 'placement_group_name', useSelfRender: true },
  { name: 'cost_type_name', useSelfRender: true },
  { name: 'total_cost', useSelfRender: true, align: 'left', sortable: true, maxWidth: '200' },
  { name: 'cash_cost', useSelfRender: true },
  { name: 'credit_cost', useSelfRender: true },
  { name: 'virtual_cost', useSelfRender: true },
  { name: 'gift_cost', useSelfRender: true },
  { name: 'wechat_debt_fixed_cost' },
  { name: 'wechat_debt_temp_cost' },
  { name: 'wechat_ecoupon_cost' },
  { name: 'wechat_special_cost' },
  { name: 'wechat_credit_cost' },
  { name: 'wechat_tcc_cost' },
  { name: 'pay_virtual_cost', useSelfRender: true },
  { name: 'insourced_give_cost', useSelfRender: true },
  { name: 'insourced_turnover_cost', useSelfRender: true },
  { name: 'return_goods_cost', useSelfRender: true },
  { name: 'operator_name', useSelfRender: true, maxWidth: '200', label: '主要运营人员' },
  { name: 'view_count', sortable: true, useSelfRender: true },
  { name: 'valid_click_count', sortable: true, useSelfRender: true },
  { name: 'ctr', sortable: true },
  { name: 'cpc', useSelfRender: true, useSelfRender: true },
  { name: 'ecpm', useSelfRender: true, useSelfRender: true },
  { name: 'conversions_count', sortable: true, useSelfRender: true },
  { name: 'conversions_rate', sortable: true },
  { name: 'conversions_cost', useSelfRender: true },
  { name: 'collocation_status_text', useSelfRender: true },
  { name: 'area_name' },
  { name: 'redcover_cost' },
  { name: 'compensate_cost' },
  { name: 'gift_android_cost' },
];
// 广告主维度报表
const advertisereport = [
  { name: 'date' },
  { name: 'uid' },
  { name: 'appid' },
  { name: 'uname' },
  { name: 'wxid' },
  { name: 'k_frame', useSelfRender: true },
  { name: 'group_name' },
  { name: 'wechat_uname' },
  { name: 'industry_name', useSelfRender: true },
  { name: 'agency_uid', useSelfRender: true },
  { name: 'operator_name', useSelfRender: true, maxWidth: '200', label: '主要运营人员' },
  { name: 'total_cost', useSelfRender: true, align: 'left', sortable: true, maxWidth: '200' },
  { name: 'view_count', useSelfRender: true },
  { name: 'valid_click_count', useSelfRender: true },
  { name: 'cash_cost', useSelfRender: true },
  { name: 'credit_cost', useSelfRender: true },
  { name: 'virtual_cost', useSelfRender: true },
  { name: 'gift_cost', useSelfRender: true },
  { name: 'ctr' },
  { name: 'cpc', useSelfRender: true, maxWidth: '200' },
  { name: 'ecpm', useSelfRender: true },
  { name: 'collocation_status_text', useSelfRender: true },
  { name: 'area_name' },
];

// 组织管理-员工管理
const employee = [
  { name: 'user_id', useSelfRender: true },
  { name: 'name', useSelfRender: true },
  { name: 'number', useSelfRender: true },
  { name: 'mobile', useSelfRender: true },
  { name: 'qq_number', useSelfRender: true },
  { name: 'wechat_number', useSelfRender: true },
  { name: 'identification_number', useSelfRender: true, minWidth: '140' },
  { name: 'email', useSelfRender: true, minWidth: '200' },
  { name: 'activate_date', useSelfRender: true, minWidth: '200' },
  { name: 'role_list', useSelfRender: true },
  { name: 'role_memo_name', useSelfRender: true },
  { name: 'post_name', useSelfRender: true },
  { name: 'type', useSelfRender: true },
  { name: 'team_list', useSelfRender: true },
  { name: 'title', useSelfRender: true },
  { name: 'seat_sip', useSelfRender: true },
  { name: 'seat_telephone', useSelfRender: true },
  { name: 'seat_mobile', useSelfRender: true },
  { name: 'seat_no', useSelfRender: true },
  { name: 'skill_group_name_list', useSelfRender: true },
  { name: 'mobile_match_status', useSelfRender: true },
  { name: 'agency_uid', useSelfRender: true },
  { name: 'spid', useSelfRender: true },
  { name: 'status', useSelfRender: true },
  { name: 'work_wechat_user_id', useSelfRender: true },
  { name: 'partner_employ_id', useSelfRender: true },
  { name: 'partner_industries', useSelfRender: true },
];
// 财务信息-gdt
const gdtinfo = [
  { name: 'uname', useSelfRender: true },
  { name: 'uid', useSelfRender: true },
  { name: 'tableShowColumns' },
  { name: 'buying_type_name', condition: 'isAdx' },
  { name: 'customer_status_name', useSelfRender: true },
  { name: 'reg_date' },
  { name: 'industry_name' },
  { name: 'total_balance', useSelfRender: true, align: 'left' },
  { name: 'predict_remain_days_name', useSelfRender: true },
  { name: 'recommended_charge_amount', align: 'right' },
  { name: 'impression_affaction_level', align: 'right' },
  { name: 'cash_balance', useSelfRender: true, align: 'right' },
  { name: 'credit_balance', useSelfRender: true, align: 'right' },
  { name: 'virtual_balance', useSelfRender: true, align: 'right' },
  { name: 'gift_balance', useSelfRender: true, align: 'right' },
  { name: 'daily_cost', useSelfRender: true, align: 'right' },
  { name: 'day_budget', useSelfRender: true, align: 'right' },
  { name: 'advertiser_bm_id', useSelfRender: true },
  { name: 'advertiser_bm_name' },
  { name: 'is_self_manage_fund', useSelfRender: true },
  { name: 'auto_transfer_valid_name' },
];

// 财务信息-cps
const cpsinfo = [
  { name: 'uname' },
  { name: 'uid' },
  { name: 'agency_uid' },
  { name: 'customer_status_name' },
  { name: 'reg_date' },
  { name: 'industry_name' },
  { name: 'total_balance', useSelfRender: true, align: 'left' },
  { name: 'cash_balance', useSelfRender: true, align: 'right' },
  { name: 'credit_balance', useSelfRender: true, align: 'right' },
];
// 财务信息-wx
const wxinfo = [
  { name: 'uname' },
  { name: 'appid' },
  { name: 'wxname' },
  { name: 'uid' },
  { name: 'wechat_account_type_name' },
  { name: 'company_name' },
  { name: 'industry_name' },
  { name: 'total_balance', useSelfRender: true },
  { name: 'cash_balance', useSelfRender: true },
  { name: 'gift_balance', useSelfRender: true },
  { name: 'inner_balance', useSelfRender: true },
  { name: 'credit_balance', useSelfRender: true, maxWidth: '200' },
  { name: 'tcc_gift_balance', useSelfRender: true, maxWidth: '200' },
  { name: 'debt_fixed_balance', useSelfRender: true },
  { name: 'debt_temp_balance', useSelfRender: true },
];
// 返货返点
const rebate = [];

// gdt财务记录
const finance_record_agency = [
  { name: 'finance_record_type' },
  { name: 'trans_time' },
  { name: 'agency_id' },
  { name: 'advertiser_name' },
  { name: 'advertiser_id' },
  { name: 'bill_no' },
  { name: 'fund_type_name' },
  { name: 'account_type_name' },
  { name: 'finance_operation_type' },
  { name: 'finance_biz_type' },
  { name: 'finance_inout_type' },
  { name: 'amount', useSelfRender: true },
  { name: 'additional_info' },
  { name: 'operator' },
];
// cps 财务记录
const finance_record_cps = [{ name: 'trans_time' }, { name: 'agency_uid' }, { name: 'uname' }, { name: 'uid' }, { name: 'bill_no' }, { name: 'app_id_group_name' }, { name: 'app_id_name' }, { name: 'trans_name' }, { name: 'amount', useSelfRender: true }, { name: 'desc' }];
// wx ad 财务记录
const wx_finance_record_advertiser = [
  { name: 'op_time' },
  { name: 'bill_no' },
  { name: 'agency_uid' },
  { name: 'uname' },
  { name: 'company_name' },
  { name: 'wxid' },
  { name: 'appid' },
  { name: 'wechat_account_type_name' },
  { name: 'sub_account_group_name' },
  { name: 'sub_account_name' },
  { name: 'advertiser_op_type' },
  { name: 'amount' },
  { name: 'recover_apply_status' },
  { name: 'op_user' },
  { name: 'desc' },
];

// wx agency 财务记录
const wx_finance_record_agency = [
  { name: 'op_time' },
  { name: 'bill_no' },
  { name: 'spid' },
  { name: 'sub_account_group_name' },
  { name: 'sub_account_name' },
  { name: 'agency_op_type' },
  { name: 'src_account' },
  { name: 'dst_account' },
  { name: 'amount' },
  { name: 'recover_apply_status' },
  { name: 'op_user' },
  { name: 'desc' },
];

const pageMap = {
  advertising,
  wechatlist,
  cpslist,
  accountlist,
  wechatrpt,
  adrpt,
  advertisereport,
  basic,
  advertisereportNew,
  employee,
  rebate,
  finance_record_agency,
  wx_finance_record_advertiser,
  wx_finance_record_agency,
  finance_record_cps,
  gdtinfo,
  wxinfo,
  cpsinfo,
};
// const pageList = [
//   { advertising },
//   { wechatlist },
//   { cpslist },
//   { accountlist },
//   { wechatrpt },
//   { adrpt },
//   { advertisereport },
//   { basic },
//   { advertisereportNew },
//   { employee },
//   { rebate },
//   { finance_record_agency },
//   { wx_finance_record_advertiser },
//   { wx_finance_record_agency },
//   { finance_record_cps },
//   { gdtinfo },
//   { wxinfo },
//   { cpsinfo },
// ];

// 获取页面所有的字段
const getAllFieldsByPageId = function (pageId) {
  return pageMap[pageId] || [];
};

// todo 等微广侧下线后uname统一名称后，此方法可删除
// 微广侧：账户名称 adq侧：账户名称
const getUNameByPageId = function (pageId) {
  let result = '';
  const unames = columnNameValueMap.uname || '';
  const temp = (unames && unames.split('|')) || [];
  const advertiser = temp[0] || [];
  const wechat = temp[1] || [];
  const isWechat = pageId.indexOf('wechat') > -1;

  result = isWechat ? wechat : advertiser;

  return result;
};

// 自定义标签封装成cellsConfig
const packageLabelCellsConfig = function (labelsMap) {
  const newMap = labelsMap.map((label) => {
    const key = Object.keys(label)[0];
    const val = label[key];

    const obj = {};
    obj.name = key;
    obj.cellName = val;
    obj.displayName = val;
    obj.align = 'left';
    obj.isLabel = true;
    return obj;
  });

  return newMap;
};

// 组装自定列配置字段属性
const packageColumns = function (fields, pageId, selfDefinitonSeletcedColumns, featureFlag = [], reName = {}, customColumns = []) {
  const fullFields = [...getAllFieldsByPageId(pageId), ...customColumns];
  const columns = selfDefinitonSeletcedColumns;
  const cells = columns.split('|');
  const fixedCells = cells[0].split(',') || [];
  const fieldsArr = fields.split(',');
  const newArr = [];
  fieldsArr.forEach((field) => {
    const obj = {};

    const filters = fullFields.filter((item) => {
      return item.name === field;
    });

    if (filters.length > 0) {
      obj.name = field;
      let nameMap = filters[0].label || columnNameValueMap[field];
      if (!_.isEmpty(reName) && reName[field]) {
        nameMap = reName[field];
      }
      const resultName = field === 'uname' ? getUNameByPageId(pageId) : nameMap;
      obj.displayName = resultName;
      obj.cellName = resultName;

      obj.align = 'left';

      if (field === '1000') {
        obj.isLabel = true;
      }

      if (fixedCells.indexOf(field) > -1) {
        // 固定列
        obj.if_default = true;
        obj.required = true;
      }
      if (featureFlag.indexOf(field) < 0) {
        newArr.push(obj);
      }
    }
  });
  return newArr;
};

// 根据自定义配置重新组装自定义列分组
const packageFullCellsGroup = (customColumns = []) => {
  const existedFieldsMap = {};
  const groupMap = cellsAttrArray.reduce((map, v) => {
    const { name, fields } = v;
    const fieldsArr = fields.split(',');
    fieldsArr.forEach((field) => {
      existedFieldsMap[field] = name;
    });
    return { ...map, [name]: fieldsArr };
  }, {});
  customColumns.forEach((v) => {
    const { name, group = '其他指标', useCustomGroup = true } = v;
    // 没有分组时，默认“其他指标”分组
    if (!groupMap[group]) {
      groupMap[group] = [];
    }
    // 前端未配置或者自定义分组优先级高时，使用自定义分组
    if (!existedFieldsMap[name]) {
      groupMap[group].push(name);
    } else if (useCustomGroup) {
      groupMap[group].push(name);
      _.remove(groupMap[existedFieldsMap[name]], (v) => v === name);
    }
  });

  return Object.keys(groupMap).map((group) => ({
    name: group,
    fields: groupMap[group].join(','),
  }));
};

/**
 * 生成自定义列全配置
 * @param {*} pageId
 * @param {*} labelMap
 * @param {*} selectedFields
 * @param {*} featureFlag
 * @param {*} haveLabel
 * @param {*} reName  有时字段名一样但对应的中文 不一样 {字段名, 需要的名}
 */
export const packageCellsConfig = function (pageId, labelMap, selectedFields, featureFlag = [], haveLabel = true, reName = {}, customColumns = []) {
  const allCellsAttrArray = packageFullCellsGroup(customColumns);
  const result = allCellsAttrArray.map((cate) => {
    const item = {};
    const { name, fields } = cate;

    if (!name) return {};

    item.name = name;
    const mapColumns = packageColumns(fields, pageId, selectedFields, featureFlag, reName, customColumns);
    if (name === '标签指标' && labelMap && haveLabel) {
      const labelColumns = packageLabelCellsConfig(labelMap);
      item.columns = [...mapColumns, ...labelColumns];
    } else {
      item.columns = mapColumns;
    }
    return item;
  });
  return {
    self_catogories: {
      name: '自定义指标',
      list: result,
    },
  };
};

// 获取页面所有列配置
export const packageTableAllColumnsConfig = function (pageId, labelMap = [], customColumns = []) {
  const basicField = getAllFieldsByPageId(pageId) || [];

  const labelField = labelMap.map((item) => {
    const key = Object.keys(item)[0];
    const val = item[key];

    return { name: key, label: val, useSelfRender: true, isLabel: true };
  });

  return [...labelField, ...basicField, ...customColumns];
};

// 拼接最完整的table字段，进行字段映射
export const packageTableSelectedColumnsConfig = function (pageId, labelMap, selectedField, reName = {}, customColumns = [], removedColumns = []) {
  // 表格的完整配置
  const tableTotalField = packageTableAllColumnsConfig(pageId, labelMap, customColumns);
  let splitArr;
  let fixedField;
  let restSelectedField;
  let concatField;

  if (selectedField && selectedField.indexOf('|') > -1) {
    splitArr = selectedField.split('|');
    fixedField = splitArr[0] || '[]';
    restSelectedField = splitArr[1] || '[]';
    concatField = [...fixedField.split(','), ...restSelectedField.split(',')];
  } else {
    fixedField = [selectedField];
    concatField = [...selectedField.split(',')];
  }

  const showFields = [];

  concatField.forEach((field) => {
    const obj = {};
    const basicFieldObj = tableTotalField.find((item) => {
      return item.name === field;
    }) || {};

    obj.name = field;

    if (isNaN(field)) {
      let nameMap = basicFieldObj.label || columnNameValueMap[field];
      if (!_.isEmpty(reName) && reName[field]) {
        nameMap = reName[field];
      }

      obj.label = field === 'uname' ? getUNameByPageId(pageId) : nameMap;
    } else {
      const filterArr = labelMap.filter((item) => {
        return Object.keys(item)[0] == field;
      });
      obj.label = filterArr && filterArr[0] ? filterArr[0][field] : '';
      if (field === '1000') {
        obj.label = '运营方式';
      }
      if (field === '1002') {
        obj.label = '客户付款类型';
      }
    }

    if (fixedField.indexOf(field) > -1) {
      // 固定列
      obj.fixedable = true;
      obj.fixedAlign = 'left';
    }
    showFields.push({ ...basicFieldObj, ...obj });

    if (basicFieldObj.siblings && basicFieldObj.siblings.length) {
      showFields.push(...basicFieldObj.siblings);
    }
  });

  return showFields.filter((x) => {
    return !!x.label && !removedColumns.includes(x.name);
  });
};

export default {
  packageCellsConfig,
  packageTableAllColumnsConfig,
  packageTableSelectedColumnsConfig,
  getDefaultColumnsByPageId,
};
